export default (slug) => {
  return slug.split('-').map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1)
  }).join(' ')
}
